<script>
  import { onMount } from 'svelte';
  import { headerDisplayStore } from "../stores/General";
  import Tabs from "../components/Tabs.svelte"
  import General from "../components/settings/General.svelte"
  import ChangePassword from "../components/settings/ChangePassword.svelte"

  let activeTabValue = 1;
  let items = [
    { label: "General",
		 value: 1,
		 component: General
		},
    { label: "Change Password",
		 value: 2,
		 component: ChangePassword
		}
  ];

  onMount(async () => {
    headerDisplayStore.SetTitle("Settings");
  });

</script>

<div class="flex flex-col h-full">
  <div class="w-full p-10">
    <div>
      <Tabs {items} {activeTabValue}/>
    </div>
  </div>
</div>